import React, { Component } from "react";
import axiosInstance from "../../axios-project";

class ProfileOverview extends Component {
    constructor(props) {
        super(props);
        this.item = {};
        this.item["name"] = localStorage.getItem("name");
        this.item["email"] = localStorage.getItem("email");
        this.item["username"] = localStorage.getItem("username");

        this.state = {
            hasChanged: false,
            errors: {},
            stateList: [],
        };
    }

    componentWillMount = () => {
        axiosInstance.get("/user/me")
            .then(response => {
                if (response.data.states) {
                    this.setState({stateList: response.data.states.map(state => state.state_name)})
                }
            })
            .catch(error => {
                console.log(error);
            })
    };

    handleChange = e => {
        this.item[e.target.name] = e.target.value;
        console.log(this.item);
        console.log(this.state.hasChanged);

        for (var key in this.item) {
            if (this.item[key] !== localStorage.getItem(key)) {
                this.setState({hasChanged: true});
                return;
            }
        }
        this.setState({hasChanged: false});
    };

    saveChanges = () => {
        console.log("Saving changes");
        // TODO: Make POST request
    };

    handleSubmit = e => {
        e.preventDefault();
        this.saveChanges()
    }

    render() {
        let role = localStorage.getItem("project_role");
        if (localStorage.getItem("role").includes("ROLE_ADMIN")) {
            role = "admin";
        }

        return (
            <div>
                <h3> Profile Overview </h3>
                <form id="profile_form" onSubmit={this.handleSubmit}>
                    <div className="form-group row">
                        <label
                            htmlFor="name_id"
                            className="col-sm-2 col-form-label leftAlign"
                        >
                            Name
                        </label>
                        <div className="col-md-2">
                            <input
                                type="text"
                                maxLength="30"
                                className="form-control"
                                id="name_id"
                                name="name"
                                readOnly={true}
                                defaultValue={this.item.name || ""}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="col-md-2">
                            {this.state.errors.username && (
                                <small className="text-danger">{this.state.errors.name} </small>
                            )}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label
                            htmlFor="username_id"
                            className="col-sm-2 col-form-label leftAlign"
                        >
                            Username
                        </label>
                        <div className="col-md-2">
                            <input
                                type="text"
                                maxLength="30"
                                className="form-control"
                                id="username_id"
                                name="username"
                                readOnly={true}
                                defaultValue={this.item.username}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="col-md-2">
                            {this.state.errors.username && (
                                <small className="text-danger">{this.state.errors.username}</small>
                            )}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label
                            htmlFor="email_id"
                            className="col-sm-2 col-form-label leftAlign"
                        >
                            Email
                        </label>
                        <div className="col-md-3">
                            <input
                                type="text"
                                maxLength="60"
                                size="30"
                                className="form-control"
                                id="email_id"
                                name="email"
                                readOnly={true}
                                defaultValue={this.item.email}
                                onChange={this.handleChange}
                            />
                        </div>
                        <div className="col-md-2">
                            {this.state.errors.email && (
                                <small className="text-danger">{this.state.errors.email}</small>
                            )}
                        </div>
                    </div>
                    <div className="form-group row">
                        <label
                            htmlFor="role_id"
                            className="col-sm-2 col-form-label leftAlign"
                        >
                            Role
                        </label>

                        <div className="col-md-2" style={{ textTransform: "capitalize" }} id="role_id">
                            {role.replace("ROLE_", "").toLocaleLowerCase()}
                        </div>
                    </div>
                    <div className="form-group row">
                    <label
                        htmlFor="state_id"
                        className="col-sm-2 col-form-label leftAlign"
                    >
                        {(this.state.stateList && this.state.stateList.length > 1) ? "Stated": "State"}
                    </label>

                    <div className="col-md-2" style={{ textTransform: "capitalize" }} id="state_id">
                        {(this.state.stateList && this.state.stateList.length > 0) ? this.state.stateList.join(", ") : "None"}
                    </div>
                </div>
                    <div className="form-group row">
                        <a href="http://www.transportationprojects.org/resetPassword.html"
                           className="float-left mx-2 btn btn-primary" role="button">Reset Password </a>
                    </div>
                    <div className="form-group row">
                    </div>
                    <div className="form-group row">
                        <button type="submit" className="btn btn-primary mx-2" disabled={!this.state.hasChanged}>
                            Save Changes
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default ProfileOverview;
